var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.87825,20.01821l11.70245-11.7149c1.8927-1.8977,1.8927-4.98412-.00178-6.88182-1.89803-1.89681-4.98211-1.89414-6.87658,.00089l-11.69889,11.71312L8.29744,1.42238C6.46156-.4149,3.2603-.41668,1.42086,1.42238-.47362,3.31919-.47362,6.40562,1.42086,8.3042l11.706,11.71401L1.396,31.7571c-1.85897,1.93235-1.80038,5.01877,.12961,6.87826,.9428,.90887,2.15193,1.36464,3.36461,1.36464,1.22156,0,2.44667-.46199,3.40722-1.3904l11.706-11.71401,11.75749,11.76465c.95523,.88133,2.20697,1.33532,3.49067,1.28557,1.2979-.05153,2.49816-.6068,3.37704-1.56187,1.70805-1.85061,1.70805-4.74868-.04971-6.65171l-11.70067-11.71401Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.1e1ef2af25f728aadba63bdb879662b9.svg";
export { ForwardRef as ReactComponent };